// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CFzy","selected":"styles_selected__1Abl2"};